import React, { useEffect, useRef } from "react";
import hero from "../assets/hero.svg";
import play from "../assets/play.svg";
import arrow from "../assets/arrow.svg";
import gsap from "gsap";

const Hero = () => {
  let ref = useRef(null);

  const timeline = gsap.timeline();

  useEffect(() => {
    const element = ref.current;

    timeline.from(element.querySelector("#left"), {
      duration: 1,
      y: 30,
      stagger: {
        amount: 0.2,
      },
    });
    timeline.from(element.querySelector("#right"), {
      duration: 0.6,
      x: 20,
      delay: 0.3,
      opacity: 1,
    });
  });

  return (
    <>
      <div
        id="home"
        ref={ref}
        className="max-w-[1240px] mx-auto pt-24 md:pt-32 pb-14 px-14 md:px-4"
      >
        <div className="grid sm:grid-cols-2 gap-4">
          <div className="flex flex-col" id="left">
            <h1>Secured Wallet Services for your Transactions</h1>
            <p className="text-justify my-4">
              Connect to our blockchain wallet service and seamlessly carry out
              transactions. Securely initiate crypto transactions, and store
              them with one simple integration.
            </p>
            <div className="flex flex-row mb-4">
              <p className="p-2 sm:p-4 bg-[#219563] text-white cursor-pointer max-w-[10rem] text-center hover:-translate-y-1">
                Get Started
              </p>
              <div className="ml-8 flex flex-row items-center cursor-pointer hover:-translate-y-1">
                <img src={play} alt="play" />
                <p className="ml-2">Watch a demo</p>
              </div>
            </div>
            <div className="flex flex-row items-center cursor-pointer hover:-translate-y-1">
              <p className="mr-2">Questions? Talk to an expert</p>
              <img src={arrow} alt="" />
            </div>
          </div>
          <div className="pt-12 sm:pt-0" id="right">
            <img src={hero} alt="hero" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
